class Gallery {
	constructor() {
		this.variables();
		this.showMoreButton();
		this.masonryGrid();
		this.lightboxGalleryOptions();
		this.bindEvents();
	}

	variables() {
		this.masonryClass = $('.masonry-grid');
		this.masonryItemClass = '.grid-item';
		this.showNumber = 8;
		// this.showNumber = Math.round(this.masonryClass.find(this.masonryItemClass).length / 10);
	}

	bindEvents() {
		$(document).on('click', '.load-more', this.loadMoreButton.bind(this));
	}

	masonryGrid() {
		let that = this;

		that.masonryClass.masonry({
			itemSelector: this.masonryItemClass,
			containerStyle: null,
		});
	}

	showMoreButton() {
		this.preloadImgs(true);
		this.masonryClass.find(this.masonryItemClass).slice(0, this.showNumber).css('visibility', 'visible').show();
		this.masonryClass.find(this.masonryItemClass + ':hidden').slice(0, this.showNumber).css('visibility', 'visible');

		if (this.masonryClass.find(this.masonryItemClass + ':hidden').length < 1) {
			$('.load-more').hide();
		}
	}

	preloadImgs(first = false) {
		let that = this;

		if (first) {
			this.masonryClass.find(this.masonryItemClass).slice(0, this.showNumber + this.showNumber).each(function () {
				let src = $(this).find('img').data('src');
				$(this).find('img').removeAttr('data-src').attr('src', src);
			});
		} else {
			this.masonryClass.find(this.masonryItemClass + ':hidden').slice(0, this.showNumber).each(function () {
				let src = $(this).find('img').data('src');
				$(this).find('img').removeAttr('data-src').attr('src', src);
			});
		}

		this.masonryClass.find(this.masonryItemClass + ' img').load(function () {
			that.masonryClass.masonry('layout');
		});
	}

	lightboxGalleryOptions() {
		lightbox.option({
			'resizeDuration': 500,
			'fitImagesInViewport': true,
			'albumLabel': "%1/%2",
			'disableScrolling': true,
			'wrapAround': true,
			'alwaysShowNavOnTouchDevices': true
		});
	}

	loadMoreButton(e) {
		e.preventDefault();
		let that = this;
		let clickedElement = e.target;
		let windowHeight = $(window).height();

		this.masonryClass.find(this.masonryItemClass + ':hidden').slice(0, this.showNumber).css('visibility', 'visible').show();

		this.masonryClass.find(this.masonryItemClass + ':hidden').slice(0, this.showNumber).css('visibility', 'visible');

		that.masonryClass.masonry('layout');

		this.masonryClass.find(this.masonryItemClass + ' img').load(function () {
			that.masonryClass.masonry('layout');
		});

		setTimeout(function () {
			$('html,body').animate({
				scrollTop: $(clickedElement).offset().top - windowHeight + 80
			}, 1000);
			that.preloadImgs();
		}, 100);


		if (this.masonryClass.find(this.masonryItemClass + ':hidden').length < 1) {
			$(clickedElement).hide();
		}

	}

}